<template>
<div>

<v-card>
	<v-card-title class="primary--text">
		<span>{{ technician != null ? 'MODIFICA TECNICO' : 'AGGIUNGI TECNICO'}}</span>
		<v-spacer></v-spacer>
		<v-icon @click="closeTechnicianDialog()">mdi-close</v-icon>
	</v-card-title>
	<v-card-text>
		<v-form ref="technicianDataForm">
			<template v-for="row in Object.keys(technicianData).length">
				<div v-if="isSectionTitle(row)" :key="`${row}_section_title`" class="section_title primary--text" v-html="printSectionTitle(row)"></div>
				<div :key="row" class="fields_row">
					<div v-for="field in technicianDataFiltered(row)" :key="`${field.id}_box`" class="field_box" :style="getFieldStyle(field.id)">
						<!-- <div 
							:key="`${field.id}_label`"
							class="mb-2 personal_data_label"
						>
							{{ field.name }}
							<span v-if="field.rules.includes('required')">*</span>
							<span v-if="field.id == 'codice_fiscale'">{{ field.readonly ? '(Automatico)' : '(Manuale)' }}</span>
						</div> -->
						<div style="display:flex;">
							<v-autocomplete
								:label="getLabel(field)"
								:key="field.id"
								v-if="field.id == 'luogo_di_nascita'"
								v-model="technicianData.luogo_di_nascita.value" 
								return-object 
								:loading="isLoadingComuniNazioni || isLoadingTechnician" 
								autocomplete="nope" 
								:items="comuniNazioni"
								item-value="id"
								:filter="(item, queryText, itemText) => customFilterByProperties(item, queryText, ['nome', 'sigla'])"
								:search-input.sync="searchComune"
								:no-data-text="isLoadingComuniNazioni ? 'In caricamento..' : (searchComune == null || searchComune.length < 2 ? 'Scrivi almeno 2 lettere per cercare' : 'Comune non trovato')"
								outlined 
								dense
								:class="`${field.id}`"
								:rules="setRules(field.rules)" 
								clearable
								clear-icon="mdi-close-circle-outline"
							>
								<template v-slot:item="data">
										{{ data.item.nome }} [{{data.item.sigla}}]
								</template>
								<template v-slot:selection="data">
										{{ data.item.nome }} [{{data.item.sigla}}]
								</template>
							</v-autocomplete>
							<v-autocomplete
								:label="getLabel(field)"
								:key="field.id"
								v-if="field.id == 'provincia'"
								v-model="technicianData.provincia.value" 
								return-object 
								:loading="isLoadingProvince || isLoadingTechnician"
								autocomplete="nope" 
								:items="province"
								item-value="id"
								item-text="nome"
								no-filter
								:search-input.sync="searchProvincia"
								:no-data-text="isLoadingProvince ? 'In caricamento..' : (searchProvincia == null || searchProvincia.length < 2 ? 'Scrivi almeno 2 lettere per cercare' : 'Provincia non trovata')"
								outlined 
								dense
								:class="`${field.id}`"
								:rules="setRules(field.rules)"
								clearable
								clear-icon="mdi-close-circle-outline"
							></v-autocomplete>
							<!-- :search-input.sync="searchCittà" -->
							<!-- :filter="(item, queryText, itemText) => { return itemText.toLowerCase().startsWith(queryText.toLowerCase()) || itemText.toLowerCase().includes(queryText.toLowerCase()) }" -->
							<v-autocomplete
								:label="getLabel(field)"
								:key="field.id"
								v-if="field.id == 'città'"
								v-model="technicianData.città.value" 
								return-object 
								:loading="isLoadingCittà || isLoadingTechnician"
								autocomplete="nope" 
								:items="città"
								item-value="id"
								item-text="nome"
								no-filter
								:search-input.sync="searchCittà"
								:no-data-text="isLoadingCittà ? 'In caricamento..' : 'Città non trovata'"
								outlined 
								dense
								:class="`${field.id}`"
								:rules="setRules(field.rules)"
								clearable
								clear-icon="mdi-close-circle-outline"
								:disabled="technicianData.provincia.value == null"
							></v-autocomplete>
							<v-autocomplete
								:label="getLabel(field)"
								:key="field.id"
								v-if="field.id == 'cap'"
								v-model="technicianData.cap.value" 
								return-object 
								:loading="isLoadingCaps || isLoadingTechnician"
								autocomplete="nope" 
								:items="caps"
								item-value="id"
								item-text="codice"
								no-filter
								:search-input.sync="searchCap"
								:no-data-text="isLoadingCaps ? 'In caricamento..' : 'CAP non trovato'"
								outlined 
								dense
								:class="`${field.id}`"
								:rules="setRules(field.rules)"
								clearable
								clear-icon="mdi-close-circle-outline"
								:disabled="technicianData.città.value == null"
							></v-autocomplete>
							<!-- <v-select
								v-if="field.type == 'select' && field.id == 'cap'"
								:items="caps"
								item-text="codice"
								item-value="codice"
								v-model="technicianData.cap.value" 
								outlined
								dense
								:class="`no_border_radius`"
								:rules="setRules(field.rules)"
								return-object
							></v-select> -->
							<v-text-field
								:label="getLabel(field)"
								v-if="field.type == 'text-field' && toggleTextField(field.disabled) && isNotThisFields(field.id)"
								:type="getFieldType(field.id)"
								v-model="field.value"
								autocomplete="nope" 
								outlined
								dense
								:class="`${field.id}`"
								:rules="setRules(field.rules)"
								:ref="field.id"
								:disabled="field.disabled"
								:loading="field.isLoading || isLoadingTechnician"
								clearable
								clear-icon="mdi-close-circle-outline"
							></v-text-field>

							<v-text-field
								:label="getLabel(field)"
								v-if="field.id == 'codice_fiscale'"
								:type="getFieldType(field.id)"
								v-model="field.value"
								autocomplete="nope" 
								outlined
								dense
								:class="`${field.id}`"
								:rules="setRules(field.rules)"
								:ref="field.id"
								:disabled="field.disabled"
								:loading="field.isLoading || isLoadingTechnician || isCheckingExistence"
								:readonly="field.readonly"
								:error-messages="fiscalCodeErrorMessages"
								:error="fiscalCodeErrorState"
							>
								<!-- <template v-slot:append v-if="field.id == 'codice_fiscale' && campiCFRiempiti() && !isCalculatingCF" > -->
								<template v-slot:append v-if="!isCalculatingCF" > <!-- Mostra icona solo se i campi per il CF sono riempiti -->
									<v-tooltip bottom>
										<template v-slot:activator="{ on }">
											<v-icon v-on="on" v-if="field.readonly" @click="field.readonly = false">mdi-pencil</v-icon>
											<v-icon v-on="on" v-else @click="ms = 0, setFiscalCodeMode()">mdi-backup-restore</v-icon>
										</template>
										<span v-if="technicianData.codice_fiscale.readonly">Modifica manualmente</span>
										<span v-else>Genera automaticamente</span>
									</v-tooltip>
								</template>
							</v-text-field>
							<!-- test precedente -->
							<!-- v-bind="minDate(getFieldType(field.id))" -->
							<v-checkbox
								:key="field.id"
								v-if="field.id == 'numero_civico'"
								v-model="isSnc"
								class="checkbox"
								label="SNC"
								@change="sncIsSelected($event, field)"
							></v-checkbox>
						</div>

						<v-menu
							v-if="field.id == 'data_di_nascita'"
							v-model="dateOfBirthMenu"
							:close-on-content-click="false"
							transition="scale-transition"
							offset-y
							max-width="290px"
							min-width="auto"
						>
							<template v-slot:activator="{ on, attrs }">
								<v-text-field
									:label="getLabel(field)"
									v-model="computedDateOfBirthFormatted"
									persistent-hint
									append-icon="mdi-calendar"
									readonly
									outlined
									dense
									:class="`no_border_radius`"
									v-bind="attrs"
									v-on="on"
									:rules="setRules(field.rules)"
									:loading="isLoadingTechnician"
									clearable
									clear-icon="mdi-close-circle-outline"
								></v-text-field>
							</template>
							<v-date-picker
								v-model="dateOfBirth"
								no-title
								@input="dateOfBirthMenu = false, handleDateInput($event, field)"
								locale="it-IT"
								max="2099-12-31"
								min="1900-12-31"
							></v-date-picker>
						</v-menu>

						<v-select
							:label="getLabel(field)"
							v-if="field.type == 'select' && field.id == 'sesso'"
							:items="technicianData.sesso.items"
							item-text="text"
							item-value="char"
							v-model="technicianData.sesso.value" 
							outlined
							dense
							:class="`no_border_radius`"
							:rules="setRules(field.rules)"
							:loading="isLoadingTechnician"
							clearable
							clear-icon="mdi-close-circle-outline"
						></v-select>
					</div>
				</div>
				<!-- v-bind="minDate(getFieldType(field.id))" -->
				<!-- <div v-if="printSeparator(row)" :key="`${row}_separator`" class="separator"></div> -->
			</template>
			<!-- <div>* Campo obbligatorio</div> -->
		</v-form>

		<!-- DIPLOMI -->
		<div class="section_title primary--text mt-6">Diplomi</div>

		<v-data-table
			:headers="coursesHeaders"
			:items="technicianCourses"
			:loading="isLoadingTechnician"
			:items-per-page="-1"
			hide-default-footer
			class="mb-5"
			disable-sort
		>
			<template
				v-slot:item.Data="{ item }"
			>
				{{ formatDate(item.Data) }}
			</template>
			<template
				v-slot:item.Elimina="{ item }"
			>
				<v-icon @click="deleteCourseFromTable(item)" color="error">mdi-close</v-icon>
			</template>
		</v-data-table>

		<div class="primary--text mb-2">Aggiungi nuovo</div>
		<v-form ref="addCourseForm">
			<div class="d-flex flex-column flex-sm-row">
				<!-- 
				Ho disabilitato il no-data-text perchè sull'evento 'focus' appare la lista di elementi con dentro solo 
				il testo 'Scrivi almeno 2 lettere per cercare' e quindi solo questo elememto viene calcolato lo spazio in basso 
				disponibile per decidere se far apparire la lista di elementi sotto o sopra. Per l'autocomplete lo spazio
				è abbastanza e quando si cerca, la lista lunga apparirà sotto e risulterà per una buona parte non visibile
				-->
				<!-- hide-no-data -->
				<!-- :no-data-text="isLoadingAlboCourses ? 'In caricamento..' : (searchAlboCourse == null || searchAlboCourse.length < 2 ? 'Scrivi almeno 2 lettere per cercare' : 'Corso non trovato')" -->
				<v-autocomplete
					label="Diploma"
					v-model="alboCourse"
					:loading="isLoadingAlboCourses"
					autocomplete="nope" 
					:items="alboCourses"
					item-value="idCorso"
					item-text="Nome"
					no-filter
					:search-input.sync="searchAlboCourse"
					outlined 
					dense
					clearable
					clear-icon="mdi-close-circle-outline"
					:rules="[rules.required, localRules.noDoubleCourse]"
					class="mr-0 mr-sm-3"
					return-object
					hide-no-data
					@click:clear="resetAlboCourse()"
				></v-autocomplete>

				<v-menu
					v-model="dateOfGraduationMenu"
					:close-on-content-click="false"
					transition="scale-transition"
					offset-y
					max-width="290px"
					min-width="auto"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
							label="Data di conseguimento"
							:value="computedDateOfGraduationFormatted"
							persistent-hint
							append-icon="mdi-calendar"
							readonly
							outlined
							dense
							v-bind="attrs"
							v-on="on"
							:rules="[rules.required]"
							:loading="isLoadingTechnician"
							class="mr-0 mr-sm-3"
							clearable
							clear-icon="mdi-close-circle-outline"
						></v-text-field>
					</template>
					<v-date-picker
						v-model="dateOfGraduation"
						no-title
						@input="dateOfGraduationMenu = false"
						locale="it-IT"
						:max="todayPlus14"
						min="1900-12-31"
					></v-date-picker>
				</v-menu>

				<v-btn @click="pushCourseToTable()" color="primary">Aggiungi</v-btn>
			</div>
		</v-form>

	</v-card-text>
	<v-card-actions>
		<v-btn v-if="env == 'local'" @click="logga()" color="success" class="ml-2">Logga</v-btn>
		<v-btn v-if="technician != null" @click="openDeleteDialog()" color="error" class="ml-2">Elimina</v-btn>
		<v-spacer></v-spacer>
		<v-alert :value="showAlert" class="mb-2 mr-6" transition="scale-transition" dense type="error">{{ alertMessage }}</v-alert>
		<v-btn @click="closeTechnicianDialog()" :class="`mb-3 mr-2 ${getSecondaryTextColorClass()}`" color="secondary">Annulla</v-btn>
		<v-btn @click="openSaveDialog()" class="mb-3 mr-2" color="primary">Salva</v-btn>
	</v-card-actions>
</v-card>

<v-dialog
	v-model="saveDialog"
	:max-width="`${ this.$vuetify.breakpoint.smAndDown ? 'unset' : '400px' }`"
	persistent
>
	<v-card>
		<v-card-title>

		</v-card-title>
		<v-card-text>
			<v-container>
				<v-row class="flex-column secondary--text" :style="`font-size: 18px; font-weight:500;`">
					<p v-if="!technicianSaved && !isSavingTechnician">
						Vuoi salvare le modifiche?
					</p>
					<div v-if="personalDataEdited && technician != null && !technicianSaved && !isSavingTechnician">
						<div class="error--text">ATTENZIONE</div>
						<div class="error--text">Hai modificato i Dati Anagrafici del Tecnico, sei sicuro di voler salvare la modifica? È un'operazione irreversibile.</div>
					</div>
          <p v-if="isSavingTechnician">
            Salvataggio in corso...
          </p>
          <v-progress-linear
            v-if="isSavingTechnician"
            color="primary"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
          <p v-if="!isSavingTechnician && technicianSaved">
            Le modifiche sono state salvate!
          </p>
				</v-row>
			</v-container>
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn v-if="!technicianSaved" @click="saveDialog = false" :class="`mb-3 ${getSecondaryTextColorClass()}`" color="secondary">Annulla</v-btn>
			<v-btn v-if="!technicianSaved" @click="saveTechnician()" class="mb-3" color="primary">Salva</v-btn>
			<v-btn v-if="technicianSaved" class="mb-3" color="primary" @click="closeSaveDialog(), closeTechnicianDialog()">Ok</v-btn>
		</v-card-actions>
	</v-card>
</v-dialog>

<v-dialog
	v-model="deleteTechnicianDialog"
	:max-width="`${ this.$vuetify.breakpoint.smAndDown ? 'unset' : '400px' }`"
	persistent
>
	<v-card>
		<v-card-title>

		</v-card-title>
		<v-card-text>
			<v-container>
				<v-row class="flex-column secondary--text" :style="`font-size: 18px; font-weight:500;`">
					<p v-if="!technicianDeleted && !isDeletingTechnician">
						Vuoi eliminare il tecnico?
					</p>
          <p v-if="isDeletingTechnician">
						Eliminazione in corso...
					</p>
          <v-progress-linear
            v-if="isDeletingTechnician"
            color="primary"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
          <p v-if="!isDeletingTechnician && technicianDeleted">
						Tecnico eliminato!
					</p>
				</v-row>
			</v-container>
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn v-if="!technicianDeleted && !isDeletingTechnician" @click="deleteTechnicianDialog = false" :class="`mb-3 ${getSecondaryTextColorClass()}`" color="secondary">Annulla</v-btn>
			<v-btn v-if="!technicianDeleted && !isDeletingTechnician" @click="deleteTechnician()" class="mb-3" color="primary">Si</v-btn>
			<v-btn v-if="technicianDeleted" class="mb-3" color="primary" @click="closeDeleteDialog(), closeTechnicianDialog()">Ok</v-btn>
		</v-card-actions>
	</v-card>
</v-dialog>

<v-dialog
	v-model="confirmCloseDialog"
	:max-width="`${ this.$vuetify.breakpoint.smAndDown ? 'unset' : '400px' }`"
	persistent
>
	<v-card>
		<v-card-title>

		</v-card-title>
		<v-card-text>
			<v-container>
				<v-row class="flex-column secondary--text" :style="`font-size: 18px; font-weight:500;`">
					<p>
						Sei sicuro di voler annullare 
						<span v-if="technician != null">le modifiche del tecnico?</span>
						<span v-if="technician == null">l'aggiunta di un tecnico?</span>
					</p>
				</v-row>
			</v-container>
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn @click="confirmCloseDialog = false" :class="`mb-3 ${getSecondaryTextColorClass()}`" color="secondary">No</v-btn>
			<v-btn class="mb-3" color="primary" @click="confirmCloseDialog = false, $emit('close-dialog')">Si</v-btn>
		</v-card-actions>
	</v-card>
</v-dialog>

</div>
</template>

<script>
import mixin from '../mixin';
import moment from "moment";
	export default {
		mixins: [mixin],
		props: ['technician'],
		data() {
			return {
				env: 'production',
				localRules: {
					noDoubleCourse: newCourse => newCourse == null || this.technicianCourses.find(course => course.idCorso == newCourse.idCorso) == undefined || 'Il corso è già in tabella',
					// fiscal_code_unique: (v) => {
					// 	if (!this.fiscalCodeExist) {
					// 		return true;
					// 	}
					// 	else {
					// 		return 'Il codice fiscale esiste già'
					// 	}
					// }
					// fiscal_code_unique: v => v == null || v == '' || !this.checkFiscalCodeExistence(v) || 'Il codice fiscale esiste già'
					// fiscal_code_unique: v => v == null || v == '' || !this.fiscalCodeExist || 'Il codice fiscale esiste già'
				},

				isLoadingTechnician: false,

				showAlert: false,
				alertMessage: '',

				personalDataEdited: false,
				confirmCloseDialog: false,

				dateOfBirthMenu: false,
				dateOfBirth: null,
				siglaProvinciaNascita: '',
				selectedSex: null, // se non uso questa variabile non funzuona il required
				technicianData: {
					nome:							{ id: 'nome', name: 'Nome', value: '', rules: ['required'], type: 'text-field', row: 1 },
					cognome:					{ id: 'cognome', name: 'Cognome', value: '', rules: ['required'], type: 'text-field', row: 1 },
					sesso:						{ id: 'sesso', name: 'Sesso', value: null, items: [{ text: 'Uomo', char: 'M' }, { text: 'Donna', char: 'F' }], rules: [], type: 'select', row: 1 },
					// luogo_di_nascita:	{ id: 'luogo_di_nascita', name: 'Luogo di nascita', value: { id: null, nome: null, sigla: null }, rules: ['required'], type: 'text-field', row: 2 },
					luogo_di_nascita:	{ id: 'luogo_di_nascita', name: 'Luogo di nascita', value: null, rules: [], type: 'text-field', row: 2 },
					data_di_nascita:	{ id: 'data_di_nascita', name: 'Data di nascita', value: null, rules: [], type: 'text-field', row: 2 },
					codice_fiscale: 	{ id: 'codice_fiscale', name: 'Codice Fiscale', value: null, rules: ['codice_fiscale'], type: 'text-field', row: 2, isLoading: false, readonly: true },
					cellulare:				{ id: 'cellulare', name: 'Cellulare', value: null, rules: ['phone_number'], type: 'text-field', row: 3 },
					telefono_fisso:		{ id: 'telefono_fisso', name: 'Telefono fisso', value: null, rules: ['phone_number'], type: 'text-field', row: 3 },
					email:						{ id: 'email', name: 'Email', value: null, rules: ['email'], type: 'text-field', row: 3 },
					info_aggiuntive: 	{ id: 'info_aggiuntive', name: 'Informazioni aggiuntive', value: null, rules: [], type: 'text-field', row: 4 },
					residenza:				{ id: 'residenza', name: 'Via/Piazza', value: null, rules: [], type: 'text-field', row: 5 },
					numero_civico:		{ id: 'numero_civico', name: 'Numero civico', value: null, rules: [], type: 'text-field', row: 5, disabled: false },
					provincia:				{ id: 'provincia', name: 'Provincia', value: null, rules: [], type: 'text-field', row: 6 },
					città:						{ id: 'città', name: 'Città', value: null, rules: [], type: 'text-field', row: 6 },
					cap:							{ id: 'cap', name: 'CAP', value: null, rules: [], type: 'text-field', row: 6 },
				},

				typUrl: '',
				sendinblueListId: null,

				isTextFieldDisabled: false,
				isSnc: false,

				// luogo di nascita
				comuniNazioni: [],
				isLoadingComuniNazioni: false,
				searchComune: null,
				
				// Residenza
				province: [],
				isLoadingProvince: false,
				searchProvincia: null,
				provinciaSelezionataId: null,
				
				città: [],
				isLoadingCittà: false,
				searchCittà: '',
				cittàSelezionataId: null,

				caps: [],
				isLoadingCaps: false,
				searchCap: '',

				ms: 0, // millisecondi del timeout
				calcolaCFAutoTimeout: null,
				isCalculatingCF: false,
				fiscalCodeErrorMessages: [],
				fiscalCodeErrorState: false,
				checkFiscalCodeExistenceTimeout: null,
				isCheckingExistence: false,
				originalFiscalCode: null, // usato in modalita modifica tecnico
				fiscalCodeExist: false,

				// tabella corsi
				coursesHeaders: [
					{ text: 'Nome del diploma', value: 'Nome' },
					{ text: 'Data conseguimento', value: 'Data' },
					{ text: 'Elimina', value: 'Elimina' },
				],
				technicianCourses: [],
				originalTechnicianCourses: [], // backup dei corsi prima delle modifiche
				technicianCoursesToSaveInDB: [],

				// selectedCourseId: null,
				// selectedCourseName: null,
				// courses: [],
				// isLoadingCourses: false,

				// autocomplete aggiungi corso
				alboCourse: {
					Nome: null,
					idCorso: null
				},
				alboCourses: [],
				searchAlboCourse: null,
				searchAlboCourseTimeout: null,
				isLoadingAlboCourses: false,

				// data conseguimento
				dateOfGraduationMenu: false,
				dateOfGraduation: null,

				// dialog salvataggio
				saveDialog: false,
				isSavingTechnician: false,
				technicianSaved: false,

				// dialog eliminazione
				deleteTechnicianDialog: false,
				isDeletingTechnician: false,
				technicianDeleted: false,
			}
		},

		watch: {
			technician: function() {
				// this.personalDataEdited = false;
				// if (this.technician != null) this.syncTechnicianProp();
			},
			
			'searchComune': function(val){
				if(val != null && val.length >= 2) this.getComuniNazioni(val);
			},
			
			'technicianData.nome': {
				handler(){
					if (this.technicianData.nome.value != null) {
						this.technicianData.nome.value = this.technicianData.nome.value.toUpperCase();
					}

					if (this.campiCFRiempiti()) this.ms = 500; // 
					this.calcolaCFAuto();

					if (!this.isLoadingTechnician) {
						this.personalDataEdited = true;
					}
				},
				deep: true
			},
			'technicianData.cognome': {
				handler(){
					if (this.technicianData.cognome.value != null) {
						this.technicianData.cognome.value = this.technicianData.cognome.value.toUpperCase();
					}

					if (this.campiCFRiempiti()) this.ms = 500; // 
					this.calcolaCFAuto();

					if (!this.isLoadingTechnician) {
						this.personalDataEdited = true;
					}
				},
				deep: true
			},
			'technicianData.sesso': {
				handler(){
					if (this.campiCFRiempiti()) this.ms = 500; // 
					this.calcolaCFAuto();

					if (!this.isLoadingTechnician) {
						this.personalDataEdited = true;
					}
				},
				deep: true
			},
			'technicianData.luogo_di_nascita': {
				handler(){
					if (this.campiCFRiempiti()) this.ms = 500; // 
					this.calcolaCFAuto();

					if (!this.isLoadingTechnician) {
						this.personalDataEdited = true;
					}
				},
				deep: true
			},
			'technicianData.data_di_nascita': {
				handler(){
					if (this.campiCFRiempiti()) this.ms = 500; // 
					this.calcolaCFAuto();

					if (!this.isLoadingTechnician) {
						this.personalDataEdited = true;
					}
				},
				deep: true
			},
			'technicianData.codice_fiscale.value': {
				handler(fiscalCode){
					fiscalCode = fiscalCode.toUpperCase();

					if (this.technicianData.codice_fiscale.value != null) {
						this.technicianData.codice_fiscale.value = fiscalCode; // per mostarlo in uppercase sul front-end
					}

					if (!this.isLoadingTechnician && !this.technicianData.codice_fiscale.readonly) {
						this.personalDataEdited = true;
					}

					if ((fiscalCode != this.originalFiscalCode && this.technician != null) || this.technician == null) {
						clearTimeout(this.checkFiscalCodeExistenceTimeout);
						this.checkFiscalCodeExistenceTimeout = setTimeout(async () => {
							this.isCheckingExistence = true;
							const response = await fetch(`/fiscal_code/exist/${fiscalCode}`);
							const data = await response.json();
							this.fiscalCodeErrorMessages = data.exist ? ['Il codice fiscale esiste già'] : [];
							this.fiscalCodeErrorState = data.exist ? true : false;
							this.isCheckingExistence = false;
						}, 500);

						
					}

					// if ((fiscalCode != this.originalFiscalCode && this.technician != null) || this.technician == null) {
					// 	console.log('fiscalCode: ' + fiscalCode);
					// 	console.log('originalFiscalCode :' + this.originalFiscalCode);
					// 	// console.log(this.technician);
					// 	this.checkFiscalCodeExistence(fiscalCode);
					// }
				},
				deep: true
			},
			'technicianData.email': {
				handler(){
					if (this.technicianData.email.value != null) {
						this.technicianData.email.value = this.technicianData.email.value.toLowerCase();
					}
					
				},
				deep: true
				
			},

			'searchProvincia': function(val){
				if(val != null && val.length >= 2 && !this.isLoadingTechnician) this.getProvince(val);
			},
			'searchCittà': function(val){
				if(val != null && val.length >= 2 && !this.isLoadingTechnician) this.getCittà(this.provinciaSelezionataId, val);
			},
			'searchCap': function(val){
				if(val != null && val.length >= 2 && !this.isLoadingTechnician) this.getCaps(this.cittàSelezionataId, val);
			},

			'technicianData.provincia.value': {
				handler(obj){
					if(obj != null && !this.isLoadingTechnician) {
						this.provinciaSelezionataId = obj.id
						this.getCittà(this.provinciaSelezionataId);
					} else if(obj == null) {
						this.province = [];
						this.città = [];
						this.caps = [];
						this.technicianData.città.value = null;
						this.technicianData.cap.value = null;
						this.provinciaSelezionataId = null;
					}
				},
				deep: true
			},
			'technicianData.città.value': {
				handler(obj){
					if(obj && !this.isLoadingTechnician) {
						this.cittàSelezionataId = obj.id
						this.getCaps(this.cittàSelezionataId);
					} else if(obj == null) {
						this.caps = [];
						this.technicianData.cap.value = null;
						this.cittàSelezionataId = null;
					}
				},
				deep: true
			},

			'searchAlboCourse': function(val){
				if(val && val.length >= 2 && val !== this.alboCourse.Nome) {
					clearTimeout(this.searchAlboCourseTimeout);
					this.searchAlboCourseTimeout = setTimeout(() => {
						this.getAlboCourses(val);
					}, 500);
					
				};
			},
		},

		computed: {
			computedDateOfBirthFormatted: {
				get() {
          if (this.dateOfBirth != null) {
						return this.formatDate(this.dateOfBirth);
					}
        },
        set(value) {
          this.dateOfBirth = value;
        }
        
      },
			computedDateOfGraduationFormatted: {
				get() {
          if (this.dateOfGraduation != null) {
						return this.formatDate(this.dateOfGraduation);
					}
					// return this.formatDate(this.dateOfGraduation);
        },
        set(value) {
          this.dateOfGraduation = value;
        }
      },
			todayPlus14() {
				return moment().add(14, 'days').format('YYYY-MM-DD');
			}
		},

		mounted() {
			if (this.technician != null) this.syncTechnicianProp();
			this.getAlboCourses();
			// Local or production?
			this.getEnv();
		},

		methods: {
			// async checkFiscalCodeExistence(fiscalCode = null) {
			// 	const response = await fetch(`/fiscal_code/exist/${fiscalCode}`);
			// 	const data = await response.json();
			// 	this.fiscalCodeExist = data.exist;
			// 	console.log('fiscalCodeExist :' + this.fiscalCodeExist);
			// 	return data.exist;
			// },
			getEnv() {
				return axios.get('/env')
				.then(res => {
					this.env = res.data;
				});
			},
			logga(value) {
				console.log(this.technicianData.sesso.value);
			},
			resetAlboCourse() {
				this.$refs.addCourseForm.reset();
				// dopo il reset devo reinserire Nome e idCorso altrimenti ricevo un errore nel watch 'searchAlboCourse'
				this.alboCourse = {
					Nome: null,
					idCorso: null
				}
				this.dateOfGraduation = null;
			},
			pushCourseToTable() {
				const isValid = this.validateForm('addCourseForm');
				if (!isValid) return;

				let newCourse = {
					Nome: this.alboCourse.Nome,
					Data: this.dateOfGraduation,
					idCorso: this.alboCourse.idCorso,
					isDeleted: 0,
					isNew: false
				}

				let foundInToSave = this.technicianCoursesToSaveInDB.find(course => course.idCorso == newCourse.idCorso);
				let foundInOriginals = this.originalTechnicianCourses.find(course => course.idCorso == newCourse.idCorso);

				// se è un nuovo diploma
				if (!foundInToSave && !foundInOriginals) {
					// console.log('!foundInToSave && !foundInOriginals');
					newCourse.isNew = true;
					this.technicianCoursesToSaveInDB.push(newCourse);
					this.technicianCourses.push(newCourse);
				}
				// se è fra i diplomi ricevuti dal back-end (originals) 
				// ed è anche fra quelli da salvare vuol dire che era stato eliminato solo dal front-end
				else if (foundInToSave && foundInOriginals && foundInToSave.isDeleted) {
					// console.log('foundInToSave && foundInOriginals');
					// se è stato aggiunto nuovamente con la data cambiata aggiorno la data
					if (foundInOriginals.Data != newCourse.Data) {
						// console.log('deleted and different data');
						foundInToSave.Data = newCourse.Data;
						foundInToSave.isDeleted = 0;
						this.technicianCourses.push(newCourse);
					}
					// altrimenti lo aggiungo solo al front-end perchè non devo aggiornare il DB
					else if (foundInOriginals.Data == newCourse.Data) {
						// console.log('deleted and same data');
						this.technicianCourses.push(newCourse);
						this.$delete(this.technicianCoursesToSaveInDB, this.technicianCoursesToSaveInDB.indexOf(foundInToSave));
					}
				}

				this.resetAlboCourse();
			},
			deleteCourseFromTable(courseToDelete) { // elimina solo dal frontend, è necessario salvare le modifiche
				/**
				 * Se è presente nei corsi che ho ricevuto dal backend vuol dire che lo devo segnare come eliminato e da salvare sul DB
				 * 
				 * Se non è presente nei corsi che ho ricevuto dal backend vuol dire che èstato aggiunto e 
				 * poi rimosso dal front-end durante la stessa operazione di modifica, quindi non lo pusho nell'array
				 * destinato al back-end
				 */
				
				let foundInToSave = this.technicianCoursesToSaveInDB.find(course => course.idCorso == courseToDelete.idCorso);
				let foundInOriginals = this.originalTechnicianCourses.find(course => course.idCorso == courseToDelete.idCorso);

				if (foundInOriginals) {
					// console.log('foundInOriginals');
					if (foundInToSave) {
						// foundInToSave.isDeleted = 1;
						// console.log(foundInToSave.Data, foundInOriginals.Data);
						// foundInToSave.Data = foundInOriginals.Data;
						// console.log(foundInToSave.Data, foundInOriginals.Data);
						this.$delete(this.technicianCourses, this.technicianCourses.indexOf(courseToDelete));
						this.$delete(this.technicianCoursesToSaveInDB, this.technicianCoursesToSaveInDB.indexOf(foundInToSave));

						let original = Object.assign({}, foundInOriginals);
						// console.log(original);
						original.isDeleted = 1;
						this.technicianCoursesToSaveInDB.push(original)
					}
					else if (!foundInToSave) {
						courseToDelete.isDeleted = 1;
						this.technicianCoursesToSaveInDB.push(courseToDelete);
						this.$delete(this.technicianCourses, this.technicianCourses.indexOf(courseToDelete));
					}
				}
				else if (!foundInOriginals) {
					// console.log('!foundInOriginals');
					this.$delete(this.technicianCourses, this.technicianCourses.indexOf(courseToDelete));
					this.$delete(this.technicianCoursesToSaveInDB, this.technicianCoursesToSaveInDB.indexOf(foundInToSave));
				}
				
				
			},
			syncTechnicianProp() {
				this.isLoadingTechnician = true;
				let capId = this.technician.idCCP;
				axios.get(`/all/${capId}`)
				.then(res => {
					if (res.data != '' && res.data != null) {
						let all = res.data;

						let provincia = {
							id: all.comune.provincia.id,
							nome: all.comune.provincia.nome,
							sigla: all.comune.provincia.sigla
						}
						this.technicianData.provincia.value = provincia;
						this.province.push(provincia);

						let città = {
							id: all.comune.id,
							nome: all.comune.nome,
						}
						this.technicianData.città.value = città;
						this.città.push(città);

						let cap = {
							id: all.id,
							codice: all.codice
						}
						this.technicianData.cap.value = cap;
						this.caps.push(cap);
					}
				})
				.then(() => {
					let luogoDiNascita = {
						id: this.technician.comuneNascita + this.technician.siglaProvinciaNascita,
						nome: this.technician.comuneNascita,
						sigla: this.technician.siglaProvinciaNascita
					}

					this.comuniNazioni.push(luogoDiNascita);
					this.technicianData.luogo_di_nascita.value = luogoDiNascita;

					this.technicianData.nome.value = this.technician.Nome;
					this.technicianData.cognome.value = this.technician.Cognome;
					this.technicianData.sesso.value = this.technician.Sesso;
					this.technicianData.data_di_nascita.value = this.technician.dataNascita;
					this.dateOfBirth = this.technician.dataNascita;
					this.technicianData.codice_fiscale.value = this.technician.codiceFiscale;
					this.originalFiscalCode = this.technician.codiceFiscale; // per escludere il codice fiscale ricevuto dal controllo
					this.technicianData.cellulare.value = this.technician.Cellulare;
					this.technicianData.telefono_fisso.value = this.technician.Telefono;
					this.technicianData.email.value = this.technician.Email;
					this.technicianData.residenza.value = this.technician.Indirizzo;
					this.technicianData.numero_civico.value = this.technician.numeroCivico;
				})
				.then(() => {
					this.technicianCourses = this.technician.corsi.map(course => {
						return {
							Nome: course.Nome,
							idCorso: course.idCorso,
							Data: course.pivot.Data,
							isDeleted: course.pivot.isDeleted,
							isNew: false
							// idTecnico: this.technician.corsi.idTecnico,
						}
					});

					// faccio un backup dei corsi
					// Object.assign(this.originalTechnicianCourses, this.technicianCourses);
					this.originalTechnicianCourses = JSON.parse(JSON.stringify(this.technicianCourses));

					// faccio un backup dei dati anagrafici, mi servono per capire se sono stati modificati
					this.originalTechnicianData = JSON.parse(JSON.stringify(this.technicianData));
				})
				.finally(() => {
					this.isLoadingTechnician = false;
				});
			},
			getLabel(field) {
				return field.name + 
					(field.rules.includes('required') ? ' *' : '') + 
					(field.id == 'codice_fiscale' ? (field.readonly ? ' (Automatico)' : ' (Manuale)') : '');
			},
			getAlboCourses(toSearch = null) {
				this.isLoadingAlboCourses = true;
				this.alboCourses = [];

				let q = `/corsi` + (toSearch != null ? '?search='+toSearch : '');

				axios.get(q)
					.then(response => {
						this.alboCourses = response.data;
					})
					.catch(err => {
						// this.$vueEventBus.$emit('showAlert', 'error', 'Errore caricando i comuni e gli stati');
					})
					.finally(() => {
						this.isLoadingAlboCourses = false;
					});
			},
			isNotThisFields(field) {
				const notTexField = ['data_di_nascita', 'luogo_di_nascita', 'codice_fiscale', 'provincia', 'città', 'cap'];
				return notTexField.includes(field) ? false : true
			},
			getComuniNazioni(toSearch = null){
				this.isLoadingComuniNazioni = true;
				this.comuniNazioni = [];

				let q = "/comuni_nazioni" + (toSearch != null ? '?search='+toSearch : '');

				axios.get(q)
					.then(response => {
						this.comuniNazioni = response.data.map(comuneNazione => {
							return {
								nome: comuneNazione.nome,
								sigla: comuneNazione.sigla,
								id: comuneNazione.nome.concat(comuneNazione.sigla) // Uso come ID la concat di nome e sigla
							}
						});
					})
					.catch(err => {
						// this.$vueEventBus.$emit('showAlert', 'error', 'Errore caricando i comuni e gli stati');
					})
					.finally(() => {
						this.isLoadingComuniNazioni = false;
					});
			},
			getProvince(toSearch = null){
				this.isLoadingProvince = true;
				this.province = [];

				let q = "/province" + (toSearch != null ? '?search='+toSearch : '');

				axios.get(q)
					.then(response => {
						this.province = response.data;
					})
					.catch(err => {
						// this.$vueEventBus.$emit('showAlert', 'error', 'Errore caricando i comuni e gli stati');
					})
					.finally(() => {
						this.isLoadingProvince = false;
					});
			},
			getCittà(provinciaId, toSearch = null){
				this.isLoadingCittà = true;
				this.città = [];

				let q = `/comuni/provincia/${provinciaId}` + (toSearch != null ? '?search='+toSearch : '');

				axios.get(q)
					.then(response => {
						this.città = response.data;
					})
					.catch(err => {
						// this.$vueEventBus.$emit('showAlert', 'error', 'Errore caricando i comuni e gli stati');
					})
					.finally(() => {
						this.isLoadingCittà = false;
					});
			},
			getCaps(comuneId, toSearch = null){
				this.isLoadingCaps = true;
				this.caps = [];

				let q = `/caps/comune/${comuneId}` + (toSearch != null ? '?search='+toSearch : '');

				axios.get(q)
					.then(response => {
						this.caps = response.data;
					})
					.catch(err => {
						// this.$vueEventBus.$emit('showAlert', 'error', 'Errore caricando i comuni e gli stati');
					})
					.finally(() => {
						this.isLoadingCaps = false;
					});
			},
			setFiscalCodeMode() {
				if (this.campiCFRiempiti()) {
					this.calcolaCFAuto();
				}
				else {
					this.technicianData.codice_fiscale.readonly = true;
					this.technicianData.codice_fiscale.value = '';
				}
			},
			calcolaCFAuto(){
				clearTimeout(this.calcolaCFAutoTimeout);
				this.calcolaCFAutoTimeout = setTimeout(function () {
					if(this.campiCFRiempiti()){
						this.technicianData.codice_fiscale.readonly = true;

						this.technicianData.codice_fiscale.isLoading = true;

						let q = "/fiscal_code/calculate?nome="+this.technicianData.nome.value+"&cognome="+this.technicianData.cognome.value+"&sesso="+this.technicianData.sesso.value+"&data_nascita="+this.technicianData.data_di_nascita.value+"&luogo_nascita="+this.technicianData.luogo_di_nascita.value.nome+"&sigla_provincia_nascita="+this.technicianData.luogo_di_nascita.value.sigla;

						axios.get(q)
						.then(response => {
							if(response.data.stato == 'ok'){
								this.technicianData.codice_fiscale.value = response.data.codiceFiscale;
							} else throw "Risposta non OK da Calcolo Codice Fiscale"; // Chiama eccezione con questo testo
						})
						.catch(err => {
								// this.$vueEventBus.$emit('showAlert', 'error', 'Errore calcolando il codice fiscale');
						})
						.finally(() => {
							this.technicianData.codice_fiscale.isLoading = false;
						});
					}
				}.bind(this), this.ms);
			},
			campiCFRiempiti(){
				if( this.technicianData.nome.value != null && this.technicianData.nome.value != "" && this.technicianData.nome.value.length >= 2 &&
					this.technicianData.cognome.value != null && this.technicianData.cognome.value != "" && this.technicianData.cognome.value.length >= 2 &&
					this.technicianData.sesso.value != null && this.technicianData.sesso.value != "" &&
					this.technicianData.data_di_nascita.value != null && this.technicianData.data_di_nascita.value != "" &&
					this.technicianData.luogo_di_nascita.value != null && this.technicianData.luogo_di_nascita.value != "" ){

					return true;
				}

				return false;
			},
			formatDate(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
			sncIsSelected(isSelected, field) {
				field.disabled = (isSelected) ? true : false;
				field.value = (isSelected) ? 'SNC' : '';
			},
			handleSelectSexInput(input, field) {
				field.value = input;
			},
			handleDateInput(input, field) {
				field.value = input;
			},
			technicianDataFiltered(row) {
				// Ho esteso la classe Object in app.js
				return Object.filter(this.technicianData, data => data.row == row);
				// return this.technicianData.filter(data => data.row == row)
			},
			getFieldType(fieldId) {
				if (fieldId == 'data_di_nascita') {
					return 'date';
				}
			},
			isSectionTitle(row) {
				const rows = [1, 3, 5];
				return rows.includes(row) ? true : false;
			},
			printSectionTitle(row) {
				switch (row) {
					case 1:
						return 'Dati Anagrafici'
						break;
					case 3:
						return 'Contatti'
						break;
					case 5:
						return "Indirizzo"
						break;
				}
			},
			printSeparator(row) {
				const rows = [2, 3, 5];
				return rows.includes(row) ? true : false
			},
			validateForm(ref) {
				// return this.$refs[ref].validate() && this.technicianCourses.length > 0;
				return this.$refs[ref].validate();
			},
			setRules(arrayOfRules) {
				let rules = [];
				arrayOfRules.forEach(rule => {
					// if (rule == 'fiscal_code_unique') {
					// 	rules.push(this.localRules[rule])
					// }
					// else {
					// 	rules.push(this.rules[rule]);
					// }

					rules.push(this.rules[rule]);
				})
				return rules;
			},
			toggleTextField(isDisabled) {
				return (isDisabled) ? false : true;
			},
			getFieldStyle(fieldId) {
				const desktopStyles = {
					// sesso: 'width 100px !important'
					// luogo_di_nascita: 'width: 250px;',
					// data_di_nascita: 'width: 200px;',
					numero_civico: 'width: 234px;',
					residenza: 'width: 400px;',
					cap: 'width: 200px',
				}

				if (this.$vuetify.breakpoint.xs) {
					return 'width: 100%';
				} else {
					if (Object.keys(desktopStyles).includes(fieldId)) {
						return desktopStyles[fieldId];
					} else {
						return 'flex: 1 1 auto;'
					}
				}
			},
			saveTechnician() {
				this.isSavingTechnician = true;
				// setTimeout(() => {
				// 	this.isSavingTechnician = false;
				// 	this.technicianSaved = true;
				// }, 2000);
				// return;

				let data = {};

				// imposto i diplomi
				data['courses'] = this.technicianCoursesToSaveInDB;

				// imposto i dati personali del tecnico
				for (const key in this.technicianData) {
					data[key] = this.technicianData[key].value;
				}

				if (this.technician != null) { // sto modificando un tecnico
					axios.patch(`/tecnici/${this.technician.idTecnico}`, data)
					.then(res => {
						this.isSavingTechnician = false;
						this.technicianSaved = true;
					})
					.catch(error => {
							// this.$vueEventBus.$emit('showAlert', 'error', 'Errore nel caricamento delle associazioni');
					})
					.finally(() => {
						this.personalDataEdited = false;
					});
				}
				else if (this.technician == null) { // sto aggiungendo un nuovo tecnico
					axios.post('/tecnici', data)
					.then(res => {
						this.isSavingTechnician = false;
						this.technicianSaved = true;
					})
					.catch(error => {
							// this.$vueEventBus.$emit('showAlert', 'error', 'Errore nel caricamento delle associazioni');
					})
					.finally(() => {
						this.personalDataEdited = false;
					});
				}
			},
			openSaveDialog() {
				let atLeastOneCourse;

				if (this.technicianCourses.length > 0) {
					atLeastOneCourse = true;
				}
				else if (this.technicianCourses.length == 0) {
					atLeastOneCourse = false;
					this.showAlert = true;
					setTimeout(() => {
						this.showAlert = false
					},5000)
					this.alertMessage = 'Devi inserire almeno un diploma';
				}

				const isValid = this.validateForm('technicianDataForm') && atLeastOneCourse && !this.fiscalCodeErrorState;
				if (!isValid) return;
				/**
				 * Imposto this.technicianSaved = false in questo punto perchè se lo faccio nella funzione 
				 * closeSaveDialog() si instravedono i bottoni poco prima della chiusura del dialog
				 */
				this.technicianSaved = false;
				this.saveDialog = true;
			},
			closeSaveDialog() {
				this.saveDialog = false;
				this.$emit('reload-table');
			},
			closeTechnicianDialog() {
				if (this.personalDataEdited) {
					this.confirmCloseDialog = true;
				}
				else {
					this.$emit('close-dialog');
				}
			},
			openDeleteDialog() {
				/**
				 * Imposto this.courseSaved = false in questo punto perchè se lo faccio nella funzione 
				 * closeSaveDialog() si instravedono i bottoni poco prima della chiusura del dialog
				 */
				this.technicianDeleted = false;
				this.deleteTechnicianDialog = true;
			},
			closeDeleteDialog() {
				this.deleteTechnicianDialog = false;
				this.$emit('reload-table');
			},
			deleteTechnician() {
				this.isDeletingTechnician = true;
				axios.delete(`/tecnici/${this.technician.idTecnico}`)
				.then(res => {
					this.isDeletingTechnician = false;
					this.technicianDeleted = true;
				})
				.catch(error => {

				})
				.finally(() => {
					//
				})
			},
		},
	}
</script>

<style lang="scss" scoped>
.hidden {
	background-color: red;
}
	// .container {
	// 	// la classe container prende in automatico i breakdown di vuetify?
	// 	margin-top: 20px;
	// 	margin-bottom: 60px;
	// 	padding: 0;
	// }
	// ::v-deep {
	// 	.checkbox label {
	// 		color: black;
	// 	}
	// 	.radio_group legend {
	// 		color: black;
	// 	}
	// 	.radio_group label {
	// 		color: black;
	// 	}
	// }
	.cs_blue {
		color: #27316e;
	}
	.cs_orange {
		color: #f1861b;
	}
	.fw_600 {
		font-weight: 600;
	}
	.fw_700 {
		font-weight: 700;
	}

	// .page_title {
	// 	text-align: center;
	// 	color: #27316e;
	// 	font-weight: 600;
	// 	margin-bottom: 30px;
	// }

	.courses_list_item:not(:last-child) {
		border-bottom:1px solid #e0e0e0;
	}

	.personal_data_wrapper {
		// margin-bottom: 50px;
	}
	.personal_data_label {
		// color: rgba(0,0,0,.6);
		font-size: 15px;
	}

	.section_title {
		font-size: 18px;
		// color: #f1861b;
		font-weight: 600;
		margin-bottom: 10px;
	}
	// .small {
	// 	color: red;
	// 	font-size: 15px;
	// }

	.numero_civico {
		margin-right: 20px;
	}

	.blue_btn_wrapper {
		display: flex;
		justify-content: center;
	}

	.blue_btn {
		cursor: pointer;
		display: inline-block;
		background-color: #27316e;
		color: white;
		padding: 7px 50px;
	}
	.blue_btn:hover {
		background-color: #f1861b;
	}

	.text_area {
		width: 100%;
	}
	.privacy {
		color: black;
	}



	@media screen and (min-width: 576px) {
		.form_title {
			text-align: center;
			font-size: 19px;;
		}
		
		.select_course_wrapper {
			display: flex;
			flex-direction: column;
			align-items: center;
			.select_course {
				width: 600px;
			}
		}

		// .personal_data_wrapper {
		// 	display: flex;
		// 	flex-direction: row;
		// 	flex-wrap: wrap;
		// }
		.fields_row {
			display: flex;
			flex-direction: row;
		}
		.field_box {
			// flex: 1 1 auto;
			&:not(:last-child) {
				margin-right: 20px;
			}
		}
		// .personal_data_label,
		// .personal_data_field {
		// 	width: 200px;
		// }
		.separator {
			width: 100%;
			height: 1px;
			border-bottom: 1px solid rgba(0, 0, 0, 0.2);
			margin: 10px 0 25px;
		}

		.text_area {
			max-width: 760px;
			width: 100%;
		}
	}

	::v-deep .radio_group .v-input--radio-group__input {
		justify-content: center;
		& legend {
			text-align: center;
			font-size: 16px;
		}
	}
</style>